import React from 'react';
import { TextVariant } from '@naf/text';
import { useNavigate, useLocation } from 'react-router';
import { Button } from '@naf-simba/elements-buttons';
import { useAuth0 } from '@auth0/auth0-react';
import { useDocumentUrl, useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import { PaywallOption } from '../../../../types/paywallOptionType';
import { PaywallLink } from '../../../../types/paywallLinkType';
import S from './styles';
import { useLoginRedirect } from '../../hooks/useLoginRedirect';
import { useTrackCTA } from '../../utils/Tracking/CtaClick/TrackCtaClick';

type Props = {
  paywallOptions: PaywallOption;
  paywallLink?: PaywallLink;
  paywallLinkSecondary?: PaywallLink;
};

export const PaywallBox = ({ paywallLink, paywallLinkSecondary, paywallOptions }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const primaryUrl = useDocumentUrlWithNode(paywallLink?.data);
  const secondaryURL = useDocumentUrl(paywallLinkSecondary?.data?.slug);
  const { isAuthenticated } = useAuth0();
  const trackCTA = useTrackCTA();
  const { redirectToLoginPage } = useLoginRedirect();

  const onloginClick = () => {
    trackCTA({
      cta_position: 'content',
      text: 'Logg inn her for tilgang',
    });
    redirectToLoginPage(`${window.location.origin}${location.pathname}`);
  };

  return (
    <S.Box>
      {!isAuthenticated && (
        <S.AlreadyAMember>
          <span>Allerede medlem? </span>
          <button type="button" onClick={onloginClick}>
            Logg inn her for tilgang
          </button>
        </S.AlreadyAMember>
      )}
      <S.MainContentWrapper>
        <S.Header variant={TextVariant.Header3}>{paywallOptions.title}</S.Header>
        {paywallOptions.description && <S.TextWrapper>{paywallOptions.description}</S.TextWrapper>}
        <S.ButtonWrapper>
          <Button
            onClick={(e: any) => {
              e.preventDefault();
              trackCTA({
                cta_position: 'content',
                text: paywallOptions.ctaText,
                url: primaryUrl,
              });
              navigate(primaryUrl);
            }}
          >
            {paywallOptions.ctaText}
          </Button>
          {paywallOptions.ctaTextSecondary ? (
            <Button
              variant="outlined"
              onClick={(e: any) => {
                e.preventDefault();
                trackCTA({
                  cta_position: 'content',
                  text: paywallOptions.ctaTextSecondary,
                  url: secondaryURL,
                });
                navigate(secondaryURL);
              }}
            >
              {paywallOptions.ctaTextSecondary}
            </Button>
          ) : null}
        </S.ButtonWrapper>
      </S.MainContentWrapper>
    </S.Box>
  );
};
